(function () {
  'use strict';

  const TOOLTIP_MSG = '予約販売商品と通常商品は同時に購入できません';

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function cartHasPreorder(cart) {
    return cart.items.some(
      (item) => item.properties && item.properties['_preorder'] === 'true'
    );
  }

  function cartHasNormal(cart) {
    return cart.items.some(
      (item) => !item.properties || item.properties['_preorder'] !== 'true'
    );
  }

  function applyGuard(btn, shouldDisable) {
    if (shouldDisable) {
      btn.disabled = true;
      btn.style.opacity = '0.4';
      btn.style.cursor = 'not-allowed';
      btn.setAttribute('title', TOOLTIP_MSG);
      btn.setAttribute('aria-disabled', 'true');
      btn.dataset.guardApplied = 'true';
    } else if (btn.dataset.guardApplied) {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
      btn.removeAttribute('title');
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.guardApplied;
    }
  }

  async function updateGuard() {
    const cart = await getCart();
    const isEmpty = cart.item_count === 0;

    if (isEmpty) {
      document.querySelectorAll('[data-guard-applied]').forEach((btn) => applyGuard(btn, false));
      return;
    }

    const hasPreorder = cartHasPreorder(cart);
    const hasNormal = cartHasNormal(cart);

    document
      .querySelectorAll('product-form[data-preorder="true"] button[type="submit"]')
      .forEach((btn) => applyGuard(btn, hasNormal));

    document
      .querySelectorAll('product-form:not([data-preorder="true"]) button[type="submit"]')
      .forEach((btn) => applyGuard(btn, hasPreorder));
  }

  function injectPreorderProperty() {
    document.querySelectorAll('product-form[data-preorder="true"]').forEach((form) => {
      const formEl = form.querySelector('form');
      if (!formEl) return;
      if (formEl.querySelector('input[name="properties[_preorder]"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_preorder]';
      input.value = 'true';
      formEl.appendChild(input);
    });
  }

  function bindCartEvents() {
    document.addEventListener('cart:refresh', updateGuard);
    document.addEventListener('cart:updated', updateGuard);

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        response.clone().json().then(() => updateGuard()).catch(() => {});
      }
      return response;
    };
  }

  function init() {
    // ページ表示直後に全ATCボタンを即時無効化
    document.querySelectorAll('button[type="submit"]').forEach((btn) => {
      btn.dataset.originalDisabled = btn.disabled;
      btn.disabled = true;
    });

    injectPreorderProperty();

    // カート確認後に正しい状態に復元
    updateGuard().then(() => {
      document.querySelectorAll('button[type="submit"]').forEach((btn) => {
        if (btn.dataset.guardApplied) return;
        btn.disabled = btn.dataset.originalDisabled === 'true';
        delete btn.dataset.originalDisabled;
      });
    });

    bindCartEvents();

    const observer = new MutationObserver(() => {
      injectPreorderProperty();
      updateGuard();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
